(() => {
  const qs = (selector, context = document) => context.querySelector(selector);
  const qsa = (selector, context = document) => [...context.querySelectorAll(selector)];

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openMenus = qsa('.mobile-menu[open], .nav-dropdown[open]');
    const containingMenu = openMenus.filter(menu => menu.contains(document.activeElement)).pop();
    openMenus.forEach(menu => { menu.open = false; });
    containingMenu?.querySelector('summary')?.focus();
  });
  document.addEventListener('click', (event) => {
    qsa('.mobile-menu[open], .nav-dropdown[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
      if (menu.contains(event.target) && event.target.closest('a')) menu.open = false;
    });
    const toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      const nav = qs('[data-mobile-nav]');
      if (!nav) return;
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      return;
    }
    if (!event.target.closest('[data-mobile-nav]') && !event.target.closest('[data-menu-toggle]')) {
      const nav = qs('[data-mobile-nav]');
      const toggleButton = qs('[data-menu-toggle]');
      if (nav && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        toggleButton?.setAttribute('aria-expanded', 'false');
      }
    }
  });

  const initializeProductGalleries = (context = document) => {
    qsa('[data-product-gallery]', context).forEach((gallery) => {
      if (gallery.dataset.galleryReady === 'true' || gallery.dataset.galleryLayout !== 'carousel') return;

      const track = qs('[data-gallery-track]', gallery);
      const slides = qsa('[data-gallery-slide]', gallery);
      const previous = qs('[data-gallery-prev]', gallery);
      const next = qs('[data-gallery-next]', gallery);
      const current = qs('[data-gallery-current]', gallery);
      const thumbnails = qsa('[data-gallery-thumb]', gallery);

      if (!track || slides.length < 1) return;
      gallery.dataset.galleryReady = 'true';

      let activeIndex = 0;
      let ticking = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const slideLeft = (slide) => {
        const trackRect = track.getBoundingClientRect();
        const slideRect = slide.getBoundingClientRect();
        return track.scrollLeft + slideRect.left - trackRect.left;
      };

      const update = (index) => {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        if (current) current.textContent = String(activeIndex + 1);
        if (previous) previous.disabled = activeIndex === 0;
        if (next) next.disabled = activeIndex === slides.length - 1;

        thumbnails.forEach((thumbnail, thumbnailIndex) => {
          const selected = thumbnailIndex === activeIndex;
          thumbnail.classList.toggle('is-active', selected);
          thumbnail.setAttribute('aria-selected', String(selected));
          if (selected && thumbnail.parentElement) {
            const rail = thumbnail.parentElement;
            const left = rail.scrollLeft + thumbnail.getBoundingClientRect().left - rail.getBoundingClientRect().left;
            if (left < rail.scrollLeft || left + thumbnail.offsetWidth > rail.scrollLeft + rail.clientWidth) {
              rail.scrollTo({ left: Math.max(0, left - (rail.clientWidth - thumbnail.offsetWidth) / 2), behavior: reducedMotion ? 'auto' : 'smooth' });
            }
          }
        });

        slides.forEach((slide, slideIndex) => {
          if (slideIndex === activeIndex) return;
          qsa('video', slide).forEach((video) => video.pause());
        });
      };

      const nearestIndex = () => {
        let nearest = 0;
        let smallestDistance = Number.POSITIVE_INFINITY;
        slides.forEach((slide, index) => {
          const distance = Math.abs(slideLeft(slide) - track.scrollLeft);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            nearest = index;
          }
        });
        return nearest;
      };

      const goTo = (index) => {
        const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
        track.scrollTo({ left: slideLeft(slides[targetIndex]), behavior: reducedMotion ? 'auto' : 'smooth' });
        update(targetIndex);
      };

      previous?.addEventListener('click', () => goTo(activeIndex - 1));
      next?.addEventListener('click', () => goTo(activeIndex + 1));
      thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => goTo(Number(thumbnail.dataset.galleryThumb))));

      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          const newIndex = nearestIndex();
          if (newIndex !== activeIndex) update(newIndex);
          ticking = false;
        });
      }, { passive: true });

      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(activeIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(activeIndex + 1);
        }
      });

      window.addEventListener('resize', () => track.scrollTo({ left: slideLeft(slides[activeIndex]), behavior: 'auto' }));
      update(0);
    });
  };

  initializeProductGalleries();
  document.addEventListener('shopify:section:load', (event) => initializeProductGalleries(event.target));


  const initializeControls = (context = document) => {
  const fresh = selector => qsa(selector, context).filter(element => {
    if (element.dataset.controlReady === 'true') return false;
    element.dataset.controlReady = 'true';
    return true;
  });
  fresh('[data-countdown]').forEach((countdown) => {
    const target = new Date(countdown.dataset.countdown).getTime();
    if (Number.isNaN(target)) return;
    const parts = {
      days: qs('[data-days]', countdown),
      hours: qs('[data-hours]', countdown),
      minutes: qs('[data-minutes]', countdown),
      seconds: qs('[data-seconds]', countdown)
    };
    const pad = (number) => String(number).padStart(2, '0');
    const update = () => {
      const remaining = Math.max(0, target - Date.now());
      if (parts.days) parts.days.textContent = pad(Math.floor(remaining / 86400000));
      if (parts.hours) parts.hours.textContent = pad(Math.floor((remaining % 86400000) / 3600000));
      if (parts.minutes) parts.minutes.textContent = pad(Math.floor((remaining % 3600000) / 60000));
      if (parts.seconds) parts.seconds.textContent = pad(Math.floor((remaining % 60000) / 1000));
    };
    update();
    window.setInterval(update, 1000);
  });

  fresh('[data-custom-upload-fields]').forEach((fields) => {
    const input = qs('[data-product-upload-input]', fields);
    const status = qs('[data-upload-status]', fields);
    const preview = qs('[data-upload-preview]', fields);
    const previewImage = qs('[data-upload-preview-image]', fields);
    const dropzone = qs('[data-upload-dropzone]', fields);
    let previewUrl = null;

    const updateUpload = () => {
      const file = input?.files?.[0];
      if (!file) {
        if (status) {
          status.textContent = 'No image selected';
          status.classList.remove('has-file');
        }
        if (preview) preview.hidden = true;
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        previewUrl = null;
        return;
      }

      if (status) {
        status.textContent = `✓ ${file.name} selected`;
        status.classList.add('has-file');
      }

      if (file.type.startsWith('image/') && preview && previewImage) {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        previewUrl = URL.createObjectURL(file);
        previewImage.src = previewUrl;
        preview.hidden = false;
        previewImage.onerror = () => {
          preview.hidden = true;
          if (status) status.textContent = file.name + ' selected (preview unavailable)';
        };
      }
    };

    input?.addEventListener('change', updateUpload);
    ['dragenter', 'dragover'].forEach((eventName) => dropzone?.addEventListener(eventName, () => dropzone.classList.add('is-dragging')));
    ['dragleave', 'drop'].forEach((eventName) => dropzone?.addEventListener(eventName, () => dropzone.classList.remove('is-dragging')));
  });

  qsa('[data-js-variant-input]', context).forEach((input) => { input.disabled = false; });

  fresh('[data-variant-select]').forEach((select) => {
    const form = select.closest('form');
    if (!form) return;
    const hidden = qs('[data-variant-id]', form);
    const price = qs('[data-product-price]', form);
    const compare = qs('[data-product-compare]', form);
    const button = qs('[data-add-to-cart]', form);

    const update = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      if (hidden) hidden.value = option.value;
      if (price) price.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableText : button.dataset.soldText;
      }
    };
    select.addEventListener('change', update);
    update();
  });

  fresh('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });
  };
  initializeControls();
  document.addEventListener('shopify:section:load', event => initializeControls(event.target));
})();
